import axios from 'axios'
import appConfig from 'configs/app.config'
import { TOKEN_TYPE, REQUEST_HEADER_AUTH_KEY, REQUEST_HEADER_AUTH_USER } from 'constants/api.constant'
import { PERSIST_STORE_NAME } from 'constants/app.constant'
import deepParseJson from 'utils/deepParseJson'
import store from '../store'
import { onSignOutSuccess } from '../store/auth/sessionSlice'

const unauthorizedCode = [401]

const BaseService = axios.create({
    timeout: 60000,
    baseURL: !appConfig.enableMock ? appConfig.apiPrefix : appConfig.mockApiPrefix,
})

BaseService.interceptors.request.use(
    (config) => {
        const { auth } = store.getState()
        let accessToken = auth?.session?.token
        let accUnqId = auth?.session?.accUnqId

        if (!accessToken || !accUnqId) {
            const rawPersistData = localStorage.getItem(PERSIST_STORE_NAME)
            const persistData = deepParseJson(rawPersistData)
            if (!accessToken) {
                accessToken = persistData?.auth?.session?.token
            }
            if (!accUnqId) {
                accUnqId = persistData?.auth?.session?.accUnqId
            }
        }

        if (accessToken) {
            config.headers[
                REQUEST_HEADER_AUTH_KEY
            ] = `${TOKEN_TYPE}${accessToken}`
        }

        if (accUnqId) {
            config.headers[
                REQUEST_HEADER_AUTH_USER
            ] = accUnqId
        }

        if (config.data instanceof FormData) {
            config.headers['Content-Type'] = 'multipart/form-data';
        }

        return config
    },
    (error) => {
        return Promise.reject(error)
    }
)

BaseService.interceptors.response.use(
    (response) => response,
    (error) => {
        const { response } = error

        if (response && unauthorizedCode.includes(response.status)) {
            store.dispatch(onSignOutSuccess())
        }

        return Promise.reject(error)
    }
)

export default BaseService
